import React from 'react';
import {
  Dialog,
  Button,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Avatar,
  ButtonGroup,
  TextField,
  Link,
  Divider,
  LinearProgress,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import { LocationOn } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import DescriptionIcon from '@material-ui/icons/Description';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import { setData, setSnackbar } from '../../redux';
import {
  getProtocolSigningUrl,
  getContractSigningUrl,
  isTicketWithTroubleProtocol,
  isTicketWithInstallationProtocol,
  sortByDate,
} from '../../../helperFunctions/index';
import TroubleProtocol from './TroubleProtocol/TroubleProtocol';
import InstallationProtocol from './InstallationProtocol/InstallationProtocol';
import { troubleProtocolActionsWithNote, installationProtocolActionsWithNote } from './constants';
import SendWithSms from './SendWithSms';
import ItsInstallProtocol from './ItsProtocols/ItsInstalProtocol';
import ItsUninstallProtocol from './ItsProtocols/ItsUninstalProtocol';
import ItsDescriptiveProtocol from './ItsProtocols/ItsDescriptiveProtocol';
import {
  getMessageForField,
  validateDescriptiveProtocol,
  handleRepresentativeJobTitleChange,
  handleRepresentativePhoneChange,
} from '../../../helperFunctions/its/itsDescriptiveProtocolHelper';
import { validateInstalationProtocol } from '../../../helperFunctions/its/itsInstalProtocolHelper';
import { validateUninstalProtocol } from '../../../helperFunctions/its/itsUninstalProtocolHelper';

export default () => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const data = useSelector(state => state.tasks.data);
  const newUsedMaterials = useSelector(state => state.tasks.newUsedMaterials);
  const startedTaskId = useSelector(state => state.tasks.taskStarted.taskId);
  const task = data.tasks.find(x => x.id === startedTaskId);
  const chechedMaterialsToSell = useSelector(state => state.tasks.chechedMaterialsToSell);

  if (!task) return null;

  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  const {
    documentsDashboard,
    installationProtocol,
    troubleProtocol,
    itsDescriptiveProtocol,
    itsInstalationProtocol,
    itsUninstalProtocol,
    itsInstaledMaterials,
    itsUninstaledMaterials,
  } = task;
  const fontSize = width <= 500 ? '4vw' : '20px';
  const smallerFontSize = width <= 500 ? '3.5vw' : '18px';

  const handleRepresentativeChange = event => {
    const updatedClientInformation = { ...documentsDashboard.clientInformation };
    updatedClientInformation.representative = event.target.value;

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, {
      ...task,
      documentsDashboard: { ...documentsDashboard, clientInformation: updatedClientInformation },
    });

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  const handleRepresentativePidChange = event => {
    const updatedClientInformation = { ...documentsDashboard.clientInformation };
    updatedClientInformation.representativePid = event.target.value;

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, {
      ...task,
      documentsDashboard: { ...documentsDashboard, clientInformation: updatedClientInformation },
    });

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  const validateContractData = () => {
    // if (!documentsDashboard.clientInformation.email) {
    //   return 'Липсва имейл!';
    // }

    return null;
  };

  const validateDocuments = isIts => {
    if (
      !troubleProtocol.open &&
      !installationProtocol.open &&
      !itsDescriptiveProtocol.open &&
      !itsUninstalProtocol.open &&
      !itsInstalationProtocol.open
    )
      return 'Изберете документ!';

    if (troubleProtocol.open) {
      const checkedCircumstances = troubleProtocol.circumstances.filter(x => x.checked);

      if (checkedCircumstances && checkedCircumstances.length === 0) {
        return 'Изберете Констатирани факти и обстоятелства!';
      }

      const circumstanceWithNote = checkedCircumstances.find(
        x => x.name === troubleProtocolActionsWithNote.circumstanceWithNote
      );

      if (
        circumstanceWithNote &&
        circumstanceWithNote.checked &&
        troubleProtocol.circumstanceNote === null
      ) {
        return 'Въведете Друго (подробности в „Забележка")!';
      }

      const checkedActionsTaken = troubleProtocol.actionsTaken.filter(x => x.checked);

      if (checkedActionsTaken && checkedActionsTaken.length === 0) {
        return 'Изберете предприети действия';
      }

      const actionTakenWithNote = checkedActionsTaken.find(
        x => x.name === troubleProtocolActionsWithNote.actionTakenWithNote
      );

      if (
        actionTakenWithNote &&
        actionTakenWithNote.checked &&
        troubleProtocol.actionTakenNote == null
      ) {
        return 'Въведете Предприети действия Друго!';
      }

      const failedActionWithNote = troubleProtocol.failedActions.find(
        x => x.name === troubleProtocolActionsWithNote.failedActionWithNote
      );

      if (
        failedActionWithNote &&
        failedActionWithNote.checked &&
        troubleProtocol.failedActionNote === null
      ) {
        return 'Въведете Други!';
      }
    }

    if (installationProtocol.open) {
      const failedActionWithNote = installationProtocol.failedActions.find(
        x => x.name === installationProtocolActionsWithNote.failedActionWithNote
      );

      if (
        failedActionWithNote &&
        failedActionWithNote.checked &&
        installationProtocol.failedActionNote === null
      ) {
        return 'Въведете Други!';
      }
    }

    if (documentsDashboard.clientInformation.isPhoneCommunication) {
      if (!documentsDashboard.clientInformation.phone) return 'Моля въведете телефон';
      const regex = /^359[0-9]{8,9}$|^0[0-9]{8,9}$|^\+359[0-9]{8,9}$/i;
      var isValidPhone = regex.test(documentsDashboard.clientInformation.phone);
      if (!isValidPhone) return 'Моля въведете валиден телефон';
    }

    if (isIts) {
      if (itsDescriptiveProtocol.open || itsInstalationProtocol.open || itsUninstalProtocol.open) {
        let itsMessages = validateItsProtocols();

        if (!documentsDashboard.clientInformation.representativePhone)
          itsMessages.push('Моля въведете телефон');
        const regex = /^359[0-9]{8,9}$|^0[0-9]{8,9}$|^\+359[0-9]{8,9}$/i;
        var isValid = regex.test(documentsDashboard.clientInformation.representativePhone);
        if (!isValid) itsMessages.push('Моля въведете валиден телефон');

        const errorTextForLessLenght =
          'Моля, опишете с повече от 3 символа длъжността на представителя/упълномощеното лице!';
        const errorTextForMoreLength =
          'Длъжността на представителя/упълномощеното лице не може да бъде над 2000 символа';
        itsMessages.push(
          getMessageForField(
            documentsDashboard.clientInformation.representativeJobTitle,
            errorTextForLessLenght,
            errorTextForMoreLength
          )
        );

        itsMessages = itsMessages.filter(m => m);

        if (itsMessages.length > 0) return itsMessages[0];
      }
    }

    return null;
  };

  const validateItsProtocols = () => {
    let messages = [];

    if (itsDescriptiveProtocol.open) {
      messages = validateDescriptiveProtocol(itsDescriptiveProtocol);
      if (messages.length > 0) return messages;
    }

    if (itsInstalationProtocol.open) {
      messages = validateInstalationProtocol(itsInstalationProtocol);
      if (messages.length > 0) return messages;
    }

    if (itsUninstalProtocol.open) {
      messages = validateUninstalProtocol(itsUninstalProtocol);
      if (messages.length > 0) return messages;
    }
    return messages;
  };

  const handleEmailChange = event => {
    const updatedClientInformation = { ...documentsDashboard.clientInformation };
    updatedClientInformation.email = event.target.value;

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, {
      ...task,
      documentsDashboard: { ...documentsDashboard, clientInformation: updatedClientInformation },
    });

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  const getSelectedSellMaterials = () => {
    const { sellMaterials } = data;

    return sellMaterials
      ? sellMaterials.filter(x => chechedMaterialsToSell.includes(x.serialNumber))
      : [];
  };

  const shouldPrintSellDeviceAnex = () => {
    const routerMessages = data.ticketRouterMessages;
    if (routerMessages[task.ticketId]) return false;

    return true;
  };

  const renderDashboardContent = () => {
    if (documentsDashboard.isLoading) {
      return <LinearProgress />;
    }

    if (
      documentsDashboard &&
      documentsDashboard.protocolSigningUrl &&
      !documentsDashboard.isProtocolSignatureRequestPending
    ) {
      return (
        <>
          <Button
            onClick={() => {
              const updatedTasks = [...data.tasks];
              updatedTasks.splice(taskIndex, 1, {
                ...task,
                documentsDashboard: { ...documentsDashboard, open: false },
              });

              dispatch(
                setData({
                  ...data,
                  tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
                })
              );
            }}
            variant="contained"
            style={{ width: '100%' }}
          >
            <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
              Затвори
            </Typography>
          </Button>
          <Button
            variant="contained"
            color="secondary"
            style={{ width: '100%' }}
            onClick={() => {
              window.open(documentsDashboard.protocolSigningUrl, '_blank');
            }}
          >
            Подпиши
          </Button>
        </>
      );
    }

    if (
      documentsDashboard &&
      documentsDashboard.protocolSigningUrl &&
      !documentsDashboard.isProtocolSignatureRequestPending
    ) {
      return (
        <>
          <Button
            onClick={() => {
              const updatedTasks = [...data.tasks];
              updatedTasks.splice(taskIndex, 1, {
                ...task,
                documentsDashboard: { ...documentsDashboard, open: false },
              });

              dispatch(
                setData({
                  ...data,
                  tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
                })
              );
            }}
            variant="contained"
            style={{ width: '100%' }}
          >
            <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
              Затвори
            </Typography>
          </Button>
          <div>Документите вече са подписани</div>
        </>
      );
    }

    return (
      <div>
        <ButtonGroup style={{ position: 'sticky', width: '100%', top: '0', zIndex: '100' }}>
          <Button
            onClick={() => {
              const updatedTasks = [...data.tasks];
              updatedTasks.splice(taskIndex, 1, {
                ...task,
                documentsDashboard: { ...documentsDashboard, open: false },
              });

              dispatch(
                setData({
                  ...data,
                  tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
                })
              );
            }}
            variant="contained"
            style={{ width: '50%' }}
          >
            <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
              Затвори
            </Typography>
          </Button>
          <Button
            variant="contained"
            color="secondary"
            style={{ width: '50%' }}
            onClick={() => {
              const validationError = validateDocuments(task.isIts);
              if (validationError) {
                dispatch(setSnackbar({ open: true, message: validationError }));
                return;
              }
              const soldDevices = getSelectedSellMaterials();
              const shouldPrintAnex = shouldPrintSellDeviceAnex();
              const protocolsData = {
                data,
                task,
                taskIndex,
                documentsDashboard,
                troubleProtocol,
                installationProtocol,
                itsDescriptiveProtocol,
                itsInstalationProtocol,
                itsUninstalProtocol,
                itsInstaledMaterials,
                itsUninstaledMaterials,
                usedMaterials: newUsedMaterials,
                soldDevices,
                shouldPrintAnex,
                dispatch,
              };

              getProtocolSigningUrl(protocolsData);
            }}
          >
            <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
              Запази
            </Typography>
          </Button>
        </ButtonGroup>
        <Card>
          <CardHeader
            avatar={
              <Avatar aria-label="recipe">
                <AssignmentIndIcon />
              </Avatar>
            }
            title="Клиентски данни"
          />
          <CardContent>
            <TextField
              label="Име"
              value={documentsDashboard.clientInformation.name}
              fullWidth
              disabled
              variant="filled"
            />
            <TextField
              label="Егн/Булстат"
              value={documentsDashboard.clientInformation.pid}
              fullWidth
              disabled
              variant="filled"
            />
            <TextField
              label="Email"
              style={{ margin: '4px', marginBottom: '10px' }}
              value={documentsDashboard.clientInformation.email ?? ''}
              fullWidth
              variant="filled"
              onChange={handleEmailChange}
            />
            {documentsDashboard.showTelesalesDocument ? <SendWithSms></SendWithSms> : <></>}
            <TextField
              label="Представител/Упълномощено лице"
              value={documentsDashboard.clientInformation.representative ?? ''}
              fullWidth
              variant="filled"
              onChange={handleRepresentativeChange}
            />
            {task.isIts ? (
              <>
                <TextField
                  label="Длъжност"
                  value={documentsDashboard.clientInformation.representativeJobTitle ?? ''}
                  fullWidth
                  variant="filled"
                  onChange={event =>
                    handleRepresentativeJobTitleChange(event, dispatch, task, data)
                  }
                />
                <TextField
                  label="GSM/Телефон"
                  value={documentsDashboard.clientInformation.representativePhone ?? ''}
                  fullWidth
                  variant="filled"
                  onChange={event => handleRepresentativePhoneChange(event, dispatch, task, data)}
                />
              </>
            ) : (
              <></>
            )}
            <TextField
              label="ЕГН на Представител/Упълномощено лице"
              value={documentsDashboard.clientInformation.representativePid ?? ''}
              fullWidth
              variant="filled"
              onChange={handleRepresentativePidChange}
            />
            <Link
              href={`https://maps.google.com/maps?q=${task.latitude},${task.longitude}`}
              target="_blank"
              rel="noreferrer"
            >
              <Typography gutterBottom component="span" style={{ fontSize }}>
                <LocationOn style={{ fontSize, marginRight: '2px' }} />
                {task.address}
              </Typography>
            </Link>
          </CardContent>
        </Card>
        <Divider />
        <Card>
          <CardHeader
            avatar={
              <Avatar aria-label="recipe">
                <DescriptionIcon />
              </Avatar>
            }
            title="Документи"
          />
          <div>
            {documentsDashboard.showTelesalesDocument ? (
              <>
                <ListItem key={`${documentsDashboard.telesalesDocument}`}>
                  <ListItemText primary={`${documentsDashboard.telesalesDocument}`} />
                </ListItem>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    const validationError = validateContractData();
                    if (validationError) {
                      dispatch(setSnackbar({ open: true, message: validationError }));
                      return;
                    }

                    if (documentsDashboard.contractSigningUrl) {
                      window.open(documentsDashboard.contractSigningUrl, '_blank');
                    } else {
                      getContractSigningUrl(data, task, taskIndex, documentsDashboard, dispatch);
                    }
                  }}
                >
                  Подпиши договор
                </Button>
              </>
            ) : (
              <></>
            )}
          </div>
          <CardContent>
            {isTicketWithTroubleProtocol(task.ticketTypeId) ? <TroubleProtocol /> : <></>}
            {isTicketWithInstallationProtocol(task.ticketTypeId) ? <InstallationProtocol /> : <></>}
            {task.isIts ? (
              <>
                <ItsDescriptiveProtocol />
                <ItsInstallProtocol />
                <ItsUninstallProtocol />
              </>
            ) : (
              <></>
            )}
          </CardContent>
        </Card>
      </div>
    );
  };

  if (documentsDashboard) {
    return (
      documentsDashboard.open && (
        <Dialog open={documentsDashboard.open} fullScreen>
          {documentsDashboard.isLoading ? <LinearProgress /> : renderDashboardContent()}
        </Dialog>
      )
    );
  }

  return <></>;
};
